import {Delete} from './Delete';

export const DeleteRoutes = {
  [Delete.DeleteTag]: (companyId: string, matchId: string, tagId: string) =>
    `/api/v1/companies/${companyId}/matches/${matchId}/match_tags/${tagId}`,
  [Delete.DeleteCompanyLocation]: (companyId: string) => `/api/v1/companies/${companyId}/locations`,
  [Delete.DeleteDepartment]: (companyId: string, departmentId: string) =>
    `/api/v1/companies/${companyId}/departments/${departmentId}`,
  [Delete.DeleteSubDepartment]: (companyId: string, departmentId: string, subDepartmentId: string) =>
    `/api/v1/companies/${companyId}/departments/${departmentId}/subdepartments/${subDepartmentId}`,
  [Delete.DeleteMatchComment]: (companyId: string, matchId: string, commentId: string) =>
    `/api/v1/companies/${companyId}/matches/${matchId}/match_comments/${commentId}`,
  [Delete.DeleteSurvey]: (companyId: string, surveyId: string) => `/api/v1/companies/${companyId}/surveys/${surveyId}`,
  [Delete.DeleteScreeningApplicant]: (companyId: string, applicantId: string) =>
    `/api/v1/companies/${companyId}/screening_applicants/${applicantId}`,
  [Delete.DeleteApplicantDocument]: (documentId: string) => `/api/v1/applicant_documents/${documentId}`,
  [Delete.DeleteDepartmentTargetProfile]: (companyId: string, departmentId: string, associationId: string) =>
    `/api/v1/companies/${companyId}/departments/${departmentId}/target_profiles/${associationId}`,
  [Delete.RemoveDepartmentTargetProfileSkill]: (
    companyId: string,
    departmentId: string,
    associationId: string,
    standardSkillId: number
  ) =>
    `/api/v1/companies/${companyId}/departments/${departmentId}` +
    `/target_profiles/${associationId}/skills/${standardSkillId}`,
};
